<template>
  <b-form-group
    label="Ekip"
    label-for="id_teams"
  >
    <validation-provider
      #default="{ errors }"
      name="Ekip"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_teams"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Ekip"
        :disabled="!dataItem.id_departments"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ProjectsTeamSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['teams/dataList']
    },
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('teams/getDataList', {
        select: [
          'teams.id AS id',
          'teams.title AS title',
        ],
        where: {
          'teams.status': 1,
        },
      })
    },
  },
}
</script>
